var jobsViewModel = null;
var id = '';
var subdomain = '';
var urlBase = 'https://setup.vensuretalent.com/public/api/JobPosting/';
var firstRun = 1;

//function loadOpenJobRequisitions() {
//    id = jQuery("#agileHrJobList").data("id");
//    subdomain = jQuery("#agileHrJobList").data("subdomain");
//    var ids = id.split("|");
//    jQuery.post(
//        {
//            url: urlBase + "RequisitionsByClient",
//            data: { clientIds: ids },
//            success: function (result) {
//                //add jobs to our global jobs variables that holds for all clients
//                if (result.Success) {
//                    loadJobList(result);
//                    jQuery("div[id*='agileHrJobList']").each(function (i, el) {
//                        jQuery(el).show();
//                    });
//                } else {
//                    loadJobList({});
//                }
//            },
//            error: function () { loadJobList({}); }
//        });
//}
//
//


function loadOpenJobRequisitions(categoriesToFilter) {
    id = jQuery("#agileHrJobList").data("id");
    subdomain = jQuery("#agileHrJobList").data("subdomain");
    var ids = id.split("|");

    // Make sure categoriesToFilter is an array (you can also check if it's empty)
    if (!Array.isArray(categoriesToFilter)) {
        categoriesToFilter = [];  // Default to an empty array if not an array
    }
    
    jQuery.post(
        {
            url: urlBase + "RequisitionsByClient",
            data: { clientIds: ids },
            success: function (result) {
                if (result.Success) {
                    var filteredJobs = result.ResultList;

                    // If categoriesToFilter is not empty, filter jobs by category
                    if (categoriesToFilter.length > 0) {
                        filteredJobs = result.ResultList.filter(function(job) {
                            return job.Department && categoriesToFilter.includes(job.Department.toLowerCase());
                        });
                    }

                    // Load the filtered (or all) jobs into the job list
                    loadJobList({ Success: result.Success, ResultList: filteredJobs });

                    jQuery("div[id*='agileHrJobList']").each(function (i, el) {
                        jQuery(el).show();
                    });
                } else {
                    loadJobList({});
                }
            },
            error: function () {
                loadJobList({});
            }
        });
}





function ViewModel(jobList) {

    var allJobs = ko.observableArray(jobList);
    var filter = ko.observable('');
    var currentJob = ko.observable(allJobs()[0]);
    var noMatchingJobsFound = ko.observable(false);
    var jobAlertRequest = ko.observable(new JobAlertRequest());

    var jobs = ko.computed(function () {
        if (!filter() || filter().length === 0) {
            return allJobs();
        } else {
            var filteredJobs = ko.utils.arrayFilter(allJobs(),
                function (job) {
                    var searchFor = filter().toLowerCase();

                    if (job.Title && job.Title.toLowerCase().includes(searchFor))
                        return true;

                    if (job.Location && job.Location.toLowerCase().includes(searchFor))
                        return true;

                    if (job.Department && job.Department.toLowerCase().includes(searchFor))
                        return true;

                    if (job.Description && job.Description.toLowerCase().includes(searchFor))
                        return true;

                    if (job.Division && job.Division.toLowerCase().includes(searchFor))
                        return true;

                    if (job.City && job.City.toLowerCase().includes(searchFor))
                        return true;

                    if (job.State && job.State.toLowerCase().includes(searchFor))
                        return true;

                    if (job.ZipCode && job.ZipCode.toLowerCase().includes(searchFor))
                        return true;

                    return false;
                });

            noMatchingJobsFound(filteredJobs.length === 0);
            return filteredJobs;
        }
    });

    return {
        jobs: jobs,
        allJobs: allJobs,
        filter: filter,
        noMatchingJobsFound: noMatchingJobsFound,
        noJobsAvailable: allJobs().length === 0,
        currentJob: currentJob,
        jobDetail: jobDetail,
        jobAlertRequest: jobAlertRequest,
        applyNowLink: applyNowLink
    }

    function JobAlertRequest() {
        var firstName = ko.observable('');
        var lastName = ko.observable('');
        var email = ko.observable('');
        var message = {
            message: ko.observable(''),
            style: ko.observable('')
        }

        var setMessage = function (className, msg) {
            message.style(className);
            message.message(msg);
        }

        var submit = function () {
            var className = 'error';
            setMessage(className, '');

            //simple validation
            if (firstName() === "") {
                setMessage(className, "First Name is required");
                return;
            }

            if (lastName() === "") {
                setMessage(className, "Last Name is required");
                return;
            }

            if (email() === "") {
                setMessage(className, "Email is required");
                return;
            }

            submitJobAlertRequest(this);
        }

        return {
            firstName: firstName,
            lastName: lastName,
            email: email,
            message: message,
            submit: submit,
            setMessage: setMessage
        };
    }

    function submitJobAlertRequest(request) {

        jQuery.post(
            {
                url: urlBase + "JobAlertSignup",
                data: {
                    ClientId: id,
                    FirstName: request.firstName(),
                    LastName: request.lastName(),
                    Email: request.email()
                },
                success: function(data) {
                    if (!data || !data.Success) {
                        request.setMessage("error", data.Message);
                    } else {
                        request.setMessage("success", data.Message);
                    }
                },
                error: function (xhr, status, error) {
                    request.setMessage("error", "An error has occurred");
                }
            });
    }

    function recordJobDetailHit(jobReqId) {
        jQuery.ajax(
            {
                type: "POST",
                url: urlBase + "RecordJobDetailHit",
                data: {
                    request: {
                        ClientId: id,
                        JobReqId: jobReqId
                    }
                }
            });
    }

    function jobDetail(action, job) {

        if (action === "close") {
            return false;
        }

        //set current job
        currentJob(job);

        recordJobDetailHit(job.Id);

        return false;
    }

    function applyNowLink(that, job) {
        return job.ApplyUrl;
    }


}
function updateJobsViewModel(newJobList) {
    if (jobsViewModel) {
        ko.cleanNode(document.body);
    }
    jobsViewModel = new ViewModel(newJobList);
    ko.applyBindings(jobsViewModel);
}






function loadJobList(data) {
    console.warn('loadJobList');
    //check for errors
    if (!data || data.Success === "false") { data.ResultList = []; }

    // Update or create the ViewModel
    updateJobsViewModel(data.ResultList);
}
